import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Expired/invalid session: clear the dead token and send hub/admin users to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("wb_token")) {
      localStorage.removeItem("wb_token");
      const p = window.location.pathname;
      if (p.startsWith("/hub") || p.startsWith("/admin")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
